import { CoverageSnippet } from '../types/assessments/assessment'

export const coverageSnippetNames: Record<CoverageSnippet, string> = {
  'basic-info': 'Basic Info',
  'call-in': 'Call In',
  'policy-owner': 'Policy Owner',
}
